import cx from "classnames";

import ButtonLink from "components/Button/ButtonLink";
import { UsdxMark } from "components/UsdxMark/UsdxMark";

type Props = {
  /** `usdx` renders the design-system lockup: brand tile + condensed wordmark. */
  variant?: "default" | "usdx";
};

export function AppHeaderLogo({ variant = "default" }: Props) {
  if (variant === "usdx") {
    return (
      <ButtonLink to="/" className="flex shrink-0 items-center gap-11 px-0 py-0">
        <UsdxMark size={38} />
        <span className="usdx-wordmark">USDX</span>
      </ButtonLink>
    );
  }

  return (
    <ButtonLink to="/" className={cx("flex items-center gap-8 px-6 py-4 text-typography-primary")}>
      <UsdxMark size={28} variant="standalone" />
      <span className="text-20 font-semibold tracking-[4px] text-typography-primary">USDX</span>
    </ButtonLink>
  );
}
